module.exports = "<div class=\"section white lighten-3\">\r\n  <div class=\"container\">\r\n    <h4 class=\"deep-orange-text\"><b>Eventos</b></h4>\r\n    <div class=\"divider deep-orange\"></div>\r\n    <br/>\r\n    <div class=\"row\">\r\n\r\n        <div *ngFor=\"let evento of eventos\">\r\n          <div class=\"col s12 m6 l4\">\r\n            <app-evento [evento]=\"evento\"></app-evento>\r\n          </div>\r\n        </div>\r\n\r\n    </div>\r\n    <!--row-->\r\n\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/hyago/Desktop/SiteEventos/src/app/inicio/eventos/eventos.component.html
// module id = ../../../../../src/app/inicio/eventos/eventos.component.html
// module chunks = main